/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLegalbirdFinancingPageMeta from "./TermsOfServiceLegalbirdFinancingPageMeta";
import Container from "../../../../../components/Container/Container";
import Layout from "../../../../Layouts/Layout";
import TermsOfServiceLegalbirdFinancing from "../../../../../components/TermsOfService/TermsOfServiceLegalbirdFinancing/TermsOfServiceLegalbirdFinancing";

const TermsOfServiceLegalbirdFinancingPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <TermsOfServiceLegalbirdFinancingPageMeta />
      <Container sectionPadding={false}>
        <TermsOfServiceLegalbirdFinancing />
      </Container>
    </Layout>
  );
};

export default TermsOfServiceLegalbirdFinancingPage;
